import { render, staticRenderFns } from "./MobileExperience.vue?vue&type=template&id=81cdbed4&scoped=true&"
import script from "./MobileExperience.vue?vue&type=script&lang=js&"
export * from "./MobileExperience.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81cdbed4",
  null
  
)

export default component.exports